import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import "./LaborCostDetailsTableHeader.scss";

export function LaborCostDetailsTableHeader(): ReactElement {
  const { t } = useTranslation("humanResources");

  return (
    <thead>
      <tr>
        <th className="cell-chevron"></th>
        <th className="cell-employee">
          {t("timeManagement.analysis.employee")}
        </th>
        <th className="cell-charge-rate">
          {t("timeManagement.analysis.chargeRate")}
        </th>
        <th className="cell-contract-start">
          {t("timeManagement.analysis.contractStart")}
        </th>
        <th className="cell-hours">{t("timeManagement.analysis.hours")}</th>
        <th className="cell-hourly-rate">
          {t("timeManagement.analysis.costRate")}
        </th>
        <th className="cell-contract-cost">
          {t("timeManagement.analysis.contract")}
        </th>
        <th className="cell-bonuses">{t("timeManagement.analysis.bonuses")}</th>
        <th className="cell-total-cost">
          {t("timeManagement.analysis.totalCost")}
        </th>
      </tr>
    </thead>
  );
}
